/**
 * What the post-sign-in step does: offer a passkey, or go straight in.
 * It never blocks the sign-in: an unsupported browser or a failed lookup
 * goes straight in.
 */
export type PasskeyOfferDecision = 'offer' | 'skip';

export type PasskeyLookup = { kind: 'listed'; count: number } | { kind: 'failed' };

export function decidePasskeyOffer(input: {
  webauthnSupported: boolean;
  lookup: PasskeyLookup;
}): PasskeyOfferDecision {
  if (!input.webauthnSupported) {
    return 'skip';
  }
  switch (input.lookup.kind) {
    case 'listed':
      return input.lookup.count === 0 ? 'offer' : 'skip';
    case 'failed':
      return 'skip';
  }
}

/** Whether this browser can create a passkey (WebAuthn). */
export function isWebAuthnSupported(): boolean {
  return typeof window !== 'undefined' && typeof window.PublicKeyCredential === 'function';
}
